import { useSuspenseQuery } from "@tanstack/react-query";
import { pathPickQueryApi } from "@/features/pathpick/api/query";
import { PathPickUsageResponse } from "@/features/pathpick/types/response";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import { toCamelKeyObject } from "@/utils/case";

// 이번 달 사용량 조회 — 사용량 카드와 플로팅 바가 공유한다(캐시 공유라 중복 요청 없음).
const useGetPathPickUsage = () => {
  const { companyId } = useCompanyIdentity();

  const { data: pathPickUsage } = useSuspenseQuery({
    queryKey: ["pathpick", "usage", companyId],
    queryFn: companyId
      ? () => pathPickQueryApi.getPathPickUsage(companyId)
      : undefined,
    select: (data) => toCamelKeyObject(data) as PathPickUsageResponse,
  });

  return { pathPickUsage };
};

export default useGetPathPickUsage;
